import { browser } from '$app/environment';
import { writable } from 'svelte/store';

const watchlistDefaultValue = 'Main watchlist';
const localStorageItem = 'watchlist_name';

const watchlistInitialValue = browser
	? window?.localStorage.getItem(localStorageItem) ?? watchlistDefaultValue
	: watchlistDefaultValue;

const activeWatchlist = writable<{
	name: string;
}>({
	name: watchlistInitialValue,
});

activeWatchlist.subscribe((watchlist) => {
	if (browser && window.localStorage) {
		window.localStorage.setItem(localStorageItem, watchlist.name);
	}
});

export default activeWatchlist;
